'use client';

import type { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    stack: {
      position: 'sticky',
      top: 0,
      zIndex: 50,
      display: 'flex',
      flexDirection: 'column',
    },
    inner: { order: 2 },
  },
  { name: 'sticky-header' },
);

type Props = { children: ReactNode };

const StickyHeader = ({ children }: Props) => {
  const classes = useStyles();
  return (
    <div className={`mobile-sticky-stack ${classes.stack}`}>
      <div className={classes.inner}>{children}</div>
    </div>
  );
};

export default StickyHeader;
